// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"FullPizza","810":"NotFound","965":"Cart"}[chunkId] + "." + {"102":"12fbc8f5","810":"ee6ecffb","965":"ad5e62ca"}[chunkId] + ".chunk.js";
};